<template>
  <Row
    class="card"
    type="flex"
    align="middle"
    :gutter="20"
    :class="'card--' + userType"
    @click.native="$router.push(`/appointments/${config.link.prop}`)"
  >
    <Col
      v-for="(col, key, index) in config"
      :key="index"
      :lg="col.lg"
    >

      <Row
        v-if="key === 'notary'"
        type="flex"
        align="middle"
      >
        <img :src="getImageSrc(data.notary.avatar_url)" class="img" />
        <span
          :class="{
            'is-disabled': isDisabled,
            'is-bold': isBold
          }"
        >
          {{ col.prop }}
        </span>
      </Row>

      <div
        v-else-if="key === 'status'"
        class="status"
      >
        <v-tag
          :text="col.prop.text"
          :color="col.prop.color"
          :is-disabled="col.prop.disabled"
          :bordered="col.prop.bordered"
        />
        <!-- <div v-if="data.status_comment">{{ data.status_comment }}</div> -->
      </div>
      <span
        v-else-if="key === 'link'"
        class="link link--arrow"
      >
        Смотреть
      </span>
      <span
        v-else
        :class="{
          'is-disabled': isDisabled,
          'is-bold': isBold
        }"
      >
        {{ col.prop }}
      </span>
    </Col>
  </Row>
</template>

<script>
import { mapGetters } from "vuex";
import getConfig from "@/constants/tables/";
import VTag from "./VTag";


export default {
  name: "UserCard",


  components: {
    VTag,
  },


  props: {
    data: {
      type: Object,
      default: () => {}
    },
    // isDisabled: {
    //   type: Boolean,
    //   default: false
    // },
    type: {
      type: String,
      default: "appointment"
    }
  },


  computed: {
    ...mapGetters({
      userType: "getUserType"
    }),

    config() {
      return getConfig(this.type, this.userType).getBody(this.data);
    },

    isDisabled() {
      return this.data.status < 0;
    },

    isBold() {
      return this.data.status === 0 || this.data.unread;
    }
  },


  methods: {
    getImageSrc(src) {
      let imgBase = require("@/assets/images/profile-photo-empty.png");
      return src ? src : imgBase;
    },
  },
};
</script>

<style lang="scss" scoped>
.card {
  border-bottom: solid 1px $gray-lighter;
  cursor: pointer;
  &:hover {
    box-shadow: 0px 0px 25px rgba(0, 0, 0, 0.08);
  }
  .is-disabled {
    color: $gray-border;
  }
  .is-bold {
    font-weight: 600;
  }
  &--client {
    min-height: 110px;
  }
  &--notary {
    min-height: 60px;
  }
  .img {
    width: 50px;
    border-radius: 50%;
    margin-right: 20px;
  }

  .status {
    margin: 10px;
  }

  .tag::v-deep {
    white-space: unset;
    margin: 10px 0px;
  }
}
</style>
